/* Built In Imports */
import { Box, Flex } from '@chakra-ui/react';
import React, { useRef, useState } from 'react';

/* External Imports */

/* Internal Imports */
import MediaEmbedV2 from '@eternal/Components/Embeds/MediaEmbedV2';
import SectionTitle from '@eternal/Components/Headings/SectionTitle';
import Slider from 'react-slick';
/* Components */
import config from '@config';
import MidContainer from '@eternal/Components/Layout/MidContainer';
import { IoChevronBackSharp, IoChevronForwardOutline } from 'react-icons/io5';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
/**
 * Renders Render VideoGallery Component
 *
 * @param {object} sectionContent - Data
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @returns {ReactElement} Render VideoGallery Component
 */

const VideoGallery = ({ sectionContent, region, lang }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const findElement = param =>
    sectionContent.find(el => el._modelApiKey === param);
  let sliderRef = useRef(null);
  const next = () => {
    sliderRef?.slickNext();
  };
  const previous = () => {
    sliderRef?.slickPrev();
  };
  const settings = {
    dots: false,
    arrows: false,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 8000,
    slidesToShow: 2.1,
    className: 'video-gallery',
    centerMode: true,
    centerPadding: '20px',
    slidesToScroll: 1,
    centerMode: false,
    infinite: true,
    afterChange: index => setActiveIndex(index),
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 834,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Box
      pos="relative"
      background="#040404"
      _before={{
        content: "''",
        width: { base: '50%', md: '20%', lg: '15%' },
        height: '100%',
        pos: 'absolute',
        backgroundImage: `${config.imgPath}/d/46272/1725007983-layer-4-copy-2-1.png`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left',
        left: '0',
        top: '0',
        zIndex: 0,
      }}
    >
      <MidContainer w="100%" ml="auto" mx="0" px="0">
        <Box>
          <SectionTitle titleObj={findElement('section_title')} />
        </Box>
        <Box
          maxW={{ xl: 1300, '2xl': 1550 }}
          ml="auto"
          mr={{ base: 'auto', lg: '0' }}
          w={{ base: '100%', lg: '95%' }}
          pos="relative"
          pl="20px"
        >
          <Slider
            ref={slider => {
              sliderRef = slider;
            }}
            {...settings}
          >
            {sectionContent
              .filter(el => el._modelApiKey === 'media_embed_v2')
              .map(el => (
                <MediaEmbedV2
                  ml={{ base: '12px', md: '20px', '2xl': '0' }}
                  sectionContent={el}
                  region={region}
                  lang={lang}
                  height={{ base: 190, sm: 265, md: 380, xl: 380 }}
                  hideBg={false}
                  w={{ base: '100%', '2xl': '100%' }}
                />
              ))}
          </Slider>

          <Flex
            onClick={previous}
            pos="absolute"
            cursor="pointer"
            alignItems="center"
            height="100%"
            w="20%"
            top={0}
            left={0}
            className="prev"
            transition="all .5s ease"
            _hover={{
              w: '20%',
              background:
                'linear-gradient(270deg, rgba(4, 4, 4, 0.00) 0%, #040404 100%)',
            }}
            display={{ base: 'none', md: 'flex' }}
          >
            <Flex
              className="prev-arrow"
              alignItems="center"
              justifyContent="center"
              border="1px solid #C9BAAB"
              color="#C9BAAB"
              w={{ base: '50px', xl: '60px' }}
              h={{ base: '50px', xl: '60px' }}
              rounded="full"
              ml="60px"
              _hover={{ border: '1px solid #fff', color: '#fff' }}
            >
              <IoChevronBackSharp size={25} />
            </Flex>
          </Flex>
          <Flex
            onClick={next}
            display={{ base: 'none', md: 'flex' }}
            pos="absolute"
            cursor="pointer"
            alignItems="center"
            justifyContent="flex-end"
            height="100%"
            w="20%"
            top={0}
            right={0}
            // _hover={{
            //   w: '100px',
            // }}
            transition="all .5s ease"
            className="next"
            _hover={{
              w: '20%',
              background:
                'linear-gradient(270deg, #040404 0%, rgba(4, 4, 4, 0.00) 100%)',
            }}
          >
            <Flex
              className="next-arrow"
              mr="60px"
              alignItems="center"
              justifyContent="center"
              border="1px solid #C9BAAB"
              color="#C9BAAB"
              w={{ base: '50px', xl: '60px' }}
              h={{ base: '50px', xl: '60px' }}
              rounded="full"
              _hover={{ border: '1px solid #fff', color: '#fff' }}
            >
              <IoChevronForwardOutline size={25} />
            </Flex>
          </Flex>
          <style global jsx>
            {`
              .next-arrow {
                visibility: hidden;
                opacity: 0;
                transition: visibility 0s, opacity 0.5s ease;
              }
              .next:hover .next-arrow {
                visibility: visible;
                opacity: 1;
              }
              .prev-arrow {
                visibility: hidden;
                opacity: 0;
                transition: visibility 0s, opacity 0.5s ease;
              }
              .prev:hover .prev-arrow {
                visibility: visible;
                opacity: 1;
              }
            `}
          </style>
        </Box>
      </MidContainer>
    </Box>
  );
};

export default VideoGallery;
